
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/syncs/create-your-first-sync",
      function () {
        return require("private-next-pages/syncs/create-your-first-sync.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/syncs/create-your-first-sync"])
      });
    }
  